import { useEffect, useCallback, RefObject } from 'react';

const useOutsideClick = (
  refs: RefObject<HTMLElement>[],
  callback: () => void,
) => {
  const handleOutsideClick = useCallback((event: MouseEvent) => {
    const shouldCallback = refs.reduce(
      (aggr, ref) =>
        aggr && ref.current && !ref.current.contains(event.target as Node),
      true,
    );

    if (shouldCallback) {
      callback();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick, false);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [handleOutsideClick]);
};

export default useOutsideClick;
